import { Component, inject } from '@angular/core';
import { DepositService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DepositCreateDto,
  DepositDto,
  DepositExcelDownloadDto,
  DepositUpdateDto,
} from '../proxy/planning/dtos/deposit';
import { DEPOSIT_CONFIG, DEPOSIT_FIELDS } from './deposit.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-deposit',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DepositService, ConfirmationService],
  templateUrl: './deposit.html',
  styleUrl: './deposit.scss',
})
export class Deposit extends BaseHierarchicalCrudComponent<
  DepositDto,
  DepositCreateDto,
  DepositUpdateDto,
  DepositExcelDownloadDto
> {
  service = inject(DepositService);
  config = DEPOSIT_CONFIG;
  fields = DEPOSIT_FIELDS;

  protected prepareUpdateDto(data: any, selected: DepositDto): DepositUpdateDto {
    return {
      name: data.name,
      code: data.code,
      managerId: data.managerId,
      vendorId: data.vendorId,
      isSapGenericDeposit: data.isSapGenericDeposit,
      address: data.address,
      psigCode: data.psigCode,
      propertyId: data.propertyId,
      batchPrefix: data.batchPrefix,
      storageLocationId: data.storageLocationId,
      trackingNumber: data.trackingNumber,
      locationId: data.locationId,
      isThirdParty: data.isThirdParty,
      zoneId: data.zoneId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Deposit';
  }
}
